// source: pbtypes/gen/eigen_lcm/Quaterniond.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.eigen_lcm.QuaterniondPb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eigen_lcm.QuaterniondPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eigen_lcm.QuaterniondPb.repeatedFields_, null);
};
goog.inherits(proto.eigen_lcm.QuaterniondPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eigen_lcm.QuaterniondPb.displayName = 'proto.eigen_lcm.QuaterniondPb';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eigen_lcm.QuaterniondPb.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eigen_lcm.QuaterniondPb.prototype.toObject = function(opt_includeInstance) {
  return proto.eigen_lcm.QuaterniondPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eigen_lcm.QuaterniondPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eigen_lcm.QuaterniondPb.toObject = function(includeInstance, msg) {
  var f, obj = {
xyzwList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eigen_lcm.QuaterniondPb}
 */
proto.eigen_lcm.QuaterniondPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eigen_lcm.QuaterniondPb;
  return proto.eigen_lcm.QuaterniondPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eigen_lcm.QuaterniondPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eigen_lcm.QuaterniondPb}
 */
proto.eigen_lcm.QuaterniondPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      reader.readPackableDoubleInto(msg.getXyzwList());
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eigen_lcm.QuaterniondPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eigen_lcm.QuaterniondPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eigen_lcm.QuaterniondPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eigen_lcm.QuaterniondPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getXyzwList();
  if (f.length > 0) {
    writer.writePackedDouble(
      3,
      f
    );
  }
};


/**
 * repeated double xyzw = 3;
 * @return {!Array<number>}
 */
proto.eigen_lcm.QuaterniondPb.prototype.getXyzwList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.eigen_lcm.QuaterniondPb} returns this
 */
proto.eigen_lcm.QuaterniondPb.prototype.setXyzwList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.eigen_lcm.QuaterniondPb} returns this
 */
proto.eigen_lcm.QuaterniondPb.prototype.addXyzw = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eigen_lcm.QuaterniondPb} returns this
 */
proto.eigen_lcm.QuaterniondPb.prototype.clearXyzwList = function() {
  return this.setXyzwList([]);
};


goog.object.extend(exports, proto.eigen_lcm);
